<script lang="ts">
    import Select from "svelte-select"
    import { getPriceCalculationByDealers } from "../../../../api"
    import { appliedPricegroups, login } from "../../../../store"
    import Modal from "../../../widgets/Modal.svelte"
    import Icon from "../../../widgets/Icon.svelte"
    import { mdiBookSearch, mdiClose } from "@mdi/js"
    import { applyPCalc } from "../../../../functions/operations/pricegroup"
    import hash from "object-hash"
    import { _ } from "svelte-i18n"

    export let operation: OperationOut

    let pCalcs: PriceCalculation[] = []
    let values: { value: string; label: string }[] = []

    const loadOptions = async () => {
        let response = await getPriceCalculationByDealers([
            $login?.account?.ident?.dealerNumber || 0,
            ...($login?.tokenData?.dealers || []),
        ])
        if (response?.data?.length) {
            pCalcs = response?.data
            values = []
            response?.data?.forEach((p) => {
                // if (p.groupName)
                values.push({
                    value: p.id,
                    label: `${p.groupName || $_("components.pcalcGroup.globalPriceGroup")} - ${$_(
                        "components.pcalcGroup.dealerNr"
                    )}: ${p?.dealerNumber}`,
                })
                if ($appliedPricegroups?.[operation?.id]) {
                    value = values?.find((p) => p.label == $appliedPricegroups?.[operation?.id]?.[0])
                }
            })
        }
        return values
    }
    let showSelect: boolean
    let value: { label: string; value: string | null } = {
        label: $_("components.pcalcGroup.selectPriceGroup"),
        value: null,
    }
    function updateValue() {
        value = values?.find((p) => p.label == $appliedPricegroups?.[operation?.id]?.[0])
        if (!value)
            value = {
                value: null,
                label: $_("components.pcalcGroup.manualInput"),
            }
    }
    $: if ($appliedPricegroups?.[operation?.id]) {
        updateValue()
    }
    $: if (!showSelect) {
        value = {
            label: $_("components.pcalcGroup.selectPriceGroup"),
            value: null,
        }
    }
</script>

<style lang="less"></style>

{#key showSelect}
    {#if !operation?.statusSummary?.emailed && !operation?.statusSummary?.orderConfimationEmailed}
        <div class="pricegroup-container">
            <div style="display: flex; gap: 10px;">
                {#if $appliedPricegroups?.[operation?.id]}
                    <div style="font-size: 0.8rem; display: flex; align-items: flex-end;">
                        {$_("components.pcalcGroup.activePriceGroup")}:&nbsp;
                        <span style="font-weight: bold;"
                            >{$appliedPricegroups?.[operation?.id]?.[0] ||
                                "Namenslos" + $appliedPricegroups?.[operation?.id]?.[0]}</span
                        >
                    </div>
                {/if}
                <button
                    class="btn btn-secondary"
                    on:click="{() => {
                        showSelect = true
                    }}"
                    >{$_("components.pcalcGroup.priceGroup")}
                    {$appliedPricegroups?.[operation?.id]
                        ? $_("components.pcalcGroup.changePriceGroup")
                        : $_("components.pcalcGroup.selectPriceGroup")}</button
                >
            </div>
        </div>
    {/if}{/key}
<Modal
    bind:show="{showSelect}"
    size="sm"
    showCloseIcon="{false}"
    on:close="{() => {
        showSelect = false
    }}"
>
    <div slot="header">{$_("components.pcalcGroup.selectPriceGroup")}</div>
    <div style="height: 200px;">
        <Select
            inputAttributes="{{ autocomplete: 'off' }}"
            placeholder=""
            showChevron="{true}"
            clearable="{true}"
            {loadOptions}
            bind:value
            on:clear="{() => {
                value = {
                    label: $_('components.pcalcGroup.selectPriceGroup'),
                    value: null,
                }
            }}"
        >
            <div slot="clear-icon">
                <Icon path="{mdiClose}" size="24px" />
            </div>
            <div slot="chevron-icon">
                <Icon path="{mdiBookSearch}" size="24px" />
            </div>
        </Select>
    </div>
    <div slot="footer">
        <div style="width: 100%; display: flex; justify-content: space-between;">
            <button
                class="btn btn-secondary"
                on:click="{() => {
                    value = {
                        label: $_('components.pcalcGroup.selectPriceGroup'),
                        value: null,
                    }
                    showSelect = false
                }}">{$_("general.cancel")}</button
            >

            <button
                class="btn"
                on:click="{() => {
                    if (pCalcs.find((e) => value?.value == e?.id))
                        applyPCalc(
                            pCalcs.find((e) => value?.value == e?.id),
                            operation
                        ).then((e) => {
                            // Ohne übergebenes formData liefert applyPCalc das
                            // OperationOut direkt; der Tupel-Fall tritt nur mit
                            // formData auf (pricegroup.ts:114-119).
                            operation = Array.isArray(e) ? e[0] : e
                            let label = value.label
                            setTimeout(() => ($appliedPricegroups[operation?.id] = [label, hash(operation)]), 100)

                            value = {
                                label: $_('components.pcalcGroup.selectPriceGroup'),
                                value: null,
                            }
                            showSelect = false
                        })
                }}">{$_("components.pcalcGroup.applyPriceGroup")}</button
            >
        </div>
    </div>
</Modal>
